window.language = {
    $langNavWrapper: null,
    $langBtn: null,
    $langOverlay: null,
    $selectCountry: null,
    $selectLang: null,
    $cookieName: "currentCountryLanguage",

    init: function ($wrapper) {
        this.$langNavWrapper = $wrapper;
        this.$langBtn = this.$langNavWrapper.querySelector('.language__current');
        this.$langOverlay = this.$langNavWrapper.querySelector('.language__overlay');
        this.$selectCountry = this.$langOverlay.querySelector('select[name="country"]');
        this.$selectLang = this.$langOverlay.querySelector('select[name="language"]');

        this.activateSelects();
        this.toggleLangOverlay(this.$langBtn);
        this.languageSelection(this.$langOverlay);
    },

    /**
     * Initialize all Select + needed Overrides like Event Listeners, Classes etc...
     */
    activateSelects: function () {
        window.VdSelect.init(this.$selectCountry);
        window.VdSelect.init(this.$selectLang);

        document.querySelectorAll('.select__custom--country ul li').forEach(item => {
            item.addEventListener('click', () => {
                window.VdSelect.destroy(this.$selectLang);
                window.VdSelect.init(this.$selectLang);
            });
        });
    },

    /**
     * Toggle Language Overlay
     */
    toggleLangOverlay: function ($selector) {
        $selector.addEventListener('click', () => {
            window.language.$langOverlay.classList.toggle('language__overlay--toggled');
            document.body.classList.toggle('overflow--hidden');
        });
    },

    /**
     * Enabled language selection via selects
     */
    languageSelection: function ($selector) {
        const $countrySelect = $selector.querySelector('select[name="country"]');
        const $languageSelect = $selector.querySelector('select[name="language"]');
        const $button = $selector.querySelector('button[name="select"]');
        const $closeButton = $selector.querySelector('.language__inner--close');

        $countrySelect.addEventListener('change', (e) => {
            const $selectedOption = $countrySelect.querySelector(`option[value="${e.currentTarget.value}"]`);
            const languageOptions = JSON.parse($selectedOption.dataset.languages);

            $languageSelect.innerHTML = '';

            Object.keys(languageOptions).forEach((languageCode, index) => {
                const { link, label , identifier } = languageOptions[languageCode];
                const $option = document.createElement('option');
                $option.value = link.uri;
                $option.innerText = label;
                $option.title = label;
                $option.dataset.country = $selectedOption.value;
                $option.dataset.lang = identifier;

                if(index === 0) {
                    const newSelected = document.createAttribute('selected');
                    $option.setAttributeNode(newSelected);
                }

                $languageSelect.appendChild($option);
            });
        });

        $button.addEventListener('click', () => {
            /** Save Current language/country in a Cookie as Json */
            const selectedLang = $languageSelect.querySelector(`option[selected]`).dataset.lang
            const selectedCountry = $countrySelect.querySelector(`option[selected]`).value
            const $cookieJson = {"country": selectedCountry, "lang": selectedLang};

            window.language.saveCountryLanguageCookie(window.languageNotice.$cookieDuration, this.$cookieName, JSON.stringify($cookieJson));

            /** Redirect to new selected language/country */
            window.location.href = $languageSelect.value;
        });

        this.toggleLangOverlay($closeButton);
    },

    /**
     * Save the Country / Language Selection in a Cookie
     *
     * @param days
     * @param name
     * @param value
     * @return void
     */
    saveCountryLanguageCookie: function(days, name, value) {
        const date = new Date();
        const time = (days * 24 * 60 * 60 * 1000);
        let expires;

        date.setTime(date.getTime() + time);
        expires = "expires=" + date.toUTCString();
        document.cookie = name + "=" + value + ";" + expires + ";path=/;SameSite=Strict;";
    }
};
